export class ImportoLiquidato {
  importo: number;
  interessi: number;
  sanzioni: number;
  id: string;
}
